<template>
    <div class="xc-base-detail-item">
        <Row class="base-detail-content">
            <Col class="base-detail-left" :span="24/span">
                <span class="base-detail-content-label content-label-left" >
                    <slot name="label-left"></slot>
                </span>
                <span class="base-detail-content-text">
                    <slot name="text-left"></slot>
                </span>
            </Col>
            <Col class="base-detail-right" :span="24/span">
                <span class="base-detail-content-label content-label-right" >
                    <slot name="label-right"></slot>
                </span>
                <span class="base-detail-content-text">
                    <slot name="text-right"></slot>
                </span>
            </Col>
        </Row>
    </div>
</template>

<script>

export default {
    name:'xc-base-detail-item',
    data(){
        return{
        }
    },
    props:{
        span:{
            type:Number,
            default:2
        }
    },
    updated(){
        let w_max_left = 0; 
        let w_max_right = 0; 
        const elLeftList = document.querySelectorAll('.content-label-left');
        const elRightList = document.querySelectorAll('.content-label-right');
        // this.$nextTick(()=>{
            for(let i=0;i<elLeftList.length;i++){
                let w = elLeftList[i].clientWidth;
                w_max_left = w > w_max_left ? w : w_max_left;
                this.$nextTick(()=>{
                     document.getElementsByClassName('content-label-left')[i].style.cssText = `min-width:${w_max_left}px`;
                 })
            }
         
            for(let j=0;j<elRightList.length;j++){
                let wRight = elRightList[j].clientWidth;
                 w_max_right = wRight > w_max_right ? wRight : w_max_right;
                 this.$nextTick(()=>{
                     document.getElementsByClassName('content-label-right')[j].style.cssText =`min-width:${w_max_right}px`;
                 })
            }
        // })
    }
}
</script>

<style lang="less" scoped>
.xc-base-detail-item{
    margin-bottom: 16px;
    &:last-child{
        margin-bottom: 0;
    }
    .base-detail-content{
        .base-detail-left{
            display: flex;
        }
        .base-detail-right{
            display: flex;
        }
        .base-detail-content-label{
            display: inline-block;
            // min-width: 80px;
            text-align: right;
            margin-right: 16px;
            font-size: 14px;
            color: #657180 ;
        }
        .base-detail-content-text{
            display: inline-block;
            word-break: break-word;
            font-size: 14px;
            color: #464C5B;
        }
    }
}
</style>
